module.exports = __webpack_public_path__ + "images/asset15.png";